import { app } from '../../library/vue-app'
import Store from './store'
import ParticipateApp from './participate-app'

app('participate', ParticipateApp)




// WEBPACK FOOTER //
// ./assets/vue/apps/participate/index.js